import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../api/client';
import { useAuth } from '../hooks/useAuth';

export function AuthVerifyPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      navigate('/login');
      return;
    }
    api<{ token: string }>(`/auth/verify?token=${encodeURIComponent(token)}`)
      .then((res) => loginWithToken(res.token))
      .then(() => navigate('/play'))
      .catch(() => navigate('/login'));
  }, [params, navigate, loginWithToken]);

  return <main className="page"><p>Connexion…</p></main>;
}

export function AuthCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();

  useEffect(() => {
    const token = params.get('token');
    if (token) {
      loginWithToken(token).then(() => navigate('/play'));
    } else {
      navigate('/login');
    }
  }, [params, navigate, loginWithToken]);

  return <main className="page"><p>Connexion Google…</p></main>;
}
